import PropTypes from 'prop-types';

export const SEASON_PROP_TYPES = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string,
  start: PropTypes.string,
  end: PropTypes.string,
});

export const SEASONS_PROP_TYPES = PropTypes.arrayOf(SEASON_PROP_TYPES);
